<template>
	<v-container fill-height pa-0>
		<transition name="fade">
			<slot name="content" v-if="condition"></slot>
		</transition>
		<transition name="fade">
			<div v-if="!condition" class="loading-screen">
				<v-progress-circular :indeterminate="true" size="100" width="7"></v-progress-circular>
			</div>
		</transition>
	</v-container>
</template>

<script>
export default {
	data: () => ({}),

	props: {
		condition: {
			default: false
		}
	}
};
</script>
